// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeMadeInUsa: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#095d8b", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M4.982 4c.267 0 .482.209.482.469v.547l1.708-.414a3.4 3.4 0 0 1 2.28.244c.93.453 2.025.453 2.955 0l.193-.094c.414-.203.9.09.9.539v5.776c0 .26-.167.494-.418.585l-.697.254a3.67 3.67 0 0 1-2.847-.144 3.65 3.65 0 0 0-2.46-.262l-1.614.39v1.641c0 .26-.215.469-.482.469a.474.474 0 0 1-.482-.469V4.47c0-.26.215-.469.482-.469m7.554 1.816a4.38 4.38 0 0 1-3.516-.132 2.4 2.4 0 0 0-.984-.24V6.63c.377.012.753.07 1.117.176l.99.289a3.46 3.46 0 0 0 2.156-.07l.237-.087zM5.464 8.94l1.376-.308a4.45 4.45 0 0 1 2.41.129l.84.287a3.47 3.47 0 0 0 2.301-.026l.147-.052V7.938a4.45 4.45 0 0 1-2.67.054l-.99-.289a3.5 3.5 0 0 0-1.73-.055l-1.684.38zm0 .963v1.024l1.378-.336a4.64 4.64 0 0 1 3.126.334 2.67 2.67 0 0 0 2.078.105l.49-.177v-.887a4.46 4.46 0 0 1-2.765-.033l-.841-.287a3.46 3.46 0 0 0-1.875-.1zm.965-3.87a.317.317 0 0 0-.322-.313.317.317 0 0 0-.321.312c0 .173.144.313.321.313s.322-.14.322-.313m.642 0c.178 0 .322-.14.322-.313a.317.317 0 0 0-.322-.313.317.317 0 0 0-.321.313c0 .172.144.312.321.312m-.642.937a.317.317 0 0 0-.322-.313.317.317 0 0 0-.321.313c0 .172.144.312.321.312s.322-.14.322-.312m.642 0c.178 0 .322-.14.322-.313a.317.317 0 0 0-.322-.312.317.317 0 0 0-.321.312c0 .173.144.313.321.313"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeMadeInUsa);
